module.exports = __webpack_public_path__ + "img/CloneRigRotationHome.ebc3e851.png";